import styled from 'styled-components'

export const InputWrap = styled.label`
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
`

export const InputLabel = styled.span`
  font-size: 14px;
  font-weight: 500;
  line-height: 15px;
  color: var(--t-text-label);
`

export const TagsContainer = styled.div`
  width: 100%;
  min-height: 42px;
  border: 1px solid var(--t-surface-2);
  background-color: var(--t-surface-2);
  border-radius: 8px;
  transition: all 0.3s;
  font-family: inherit;
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  padding: 10px 40px 10px 16px;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  position: relative;

  &:not(:focus-within):hover {
    border-color: var(--t-input-hover);
  }

  &:focus-within {
    border-color: var(--t-action-accent);
  }

  &:disabled {
    background-color: var(--t-input-bg-disabled);
    border-color: var(--t-input-border-disabled);
    color: ar(--t-input-text-disabled);
    pointer-events: none;
  }
`

export const PlaceholderStyled = styled.span`
  color: var(--t-text-secondary);
  font-size: 14px;
  line-height: 1.4;
`

export const TagStyled = styled.div`
  padding: 5px 8px;
  border-radius: 16px;
  color: ${(p) => p.color};
  background-color: ${(p) => p.bgColor};
  font-size: 12px;
  line-height: 1.1;
  display: flex;
  align-items: center;
  gap: 5px;
`

export const TagButton = styled.button`
  align-self: center;
  cursor: pointer;

  svg {
    display: block;
    color: ${(p) => p.color};
  }
`

export const InputContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`

export const Input = styled.input`
  border: none;
  outline: none;
  font-size: 14px;
  line-height: 1.4;
  color: var(--t-text-input);
  background-color: inherit;
`

export const SuggestionWrap = styled.span`
  color: var(--p-neutral-500);
  font-size: 14px;
  line-height: 1.4;
`

export const HiddenSpan = styled.span`
  position: absolute;
  visibility: hidden;
  white-space: pre;
  font-size: 14px;
  line-height: 1.4;
  font-family: inherit;
`

export const MatchingTagsContainer = styled.div`
  padding: 16px;
  border-radius: 6px;
  color: var(--p-neutral-500);
  display: flex;
  flex-wrap: wrap;
  gap: 8px 4px;
  box-shadow:
    0px 2px 2px -1px rgba(27, 35, 44, 0.04),
    0px 8px 16px -2px rgba(27, 36, 44, 0.12);
  border: 1px solid var(--t-select-popover-border);
  position: absolute;
  top: 110%;
  z-index: 100;
  background-color: var(--t-select-popover-bg);
  width: 100%;
`
export const MatchingTag = styled.div`
  cursor: pointer;
`
export const ArrowIcon = styled.div`
  cursor: pointer;
  color: var(--p-neutral-500);
  position: absolute;
  top: 50%;
  right: 18px;
  transform: translateY(-50%);

  svg {
    display: block;
  }
`
